import { HTTP } from '../../services/api-service.js';
import commonObj from '../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;

const commonStore = {
    namespaced: true,
    state: {
        totalItem: 0,
        q: {
            tableNeedQuery: "",
            isOuterJoin: false,
            searchCriteria: "",
            orderBy: "",
            take: 1000000,
            skip: 0
        },
        currentSelectedPage: 0
    },
    actions: {
        calculateDueDate({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/retrieveduedate', { fromDate: param.fromDate, termCode: param.termCode }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getTxPrefixList({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/GetTxPrefixList', { comp: common.getCompanyName(), TxType: param.txType }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getTxTypeList({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/GetTxTypeList').then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getEntityNoList({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/CustomerSelection', { companyCode: common.getCompanyName(), slsManCode: "" }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getVendorsAndFactory({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/vendorselectionexcludeclosedandblklist').then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getLocationCodeList({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/customerlocationselectionbyloc', { custCode: param.custCode, CustLocCode: param.CustLocCode, slsManCode: param.slsManCode, lang: param.lang }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getSalesmanList({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/GetSalesmanSelection', { custCode: param.custCode, addressCode: param.addressCode, salesman: param.salesman }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getSysStatusList({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/GetSysStatusList', { TxType: param.TxType }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getAllUOMList({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/getalluoms').then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getUOMDimension({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/uomdim', { UOM: param.UOM }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getUOMListByDim({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/getuomlistbydim', { uomDIM: param.uomDIM }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getUOMListByItemNum({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/getuomlist', { companyCode: common.getCompanyName(), itemNum: param.itemNum }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        expTx({ commit, state }, param) {
            // debugger;
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/stock/ExportTransactions',
                    {
                        dateFrom: param.dateFrom,
                        dateTo: param.dateTo,
                        txType: param.txType,
                        fromTxNum:
                            param.fromTxNum,
                        toTxNum: param.toTxNum,
                        fromEntNum: param.fromEntNum,
                        toEntNum: param.toEntNum,
                        fromSls: param.fromSls,
                        toSls: param.toSls
                    }).then(response => {
                        resolve(response);
                    })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        matchUOMDim({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/UOMDimMatch', { UOM1: param.UOM1, UOM2: param.UOM2 }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        retrieveCustomerInfo({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/retrievecustomerinfo', { companyCode: common.getCompanyName(), customerCode: param.customerCode }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getItemPrice({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/GetItemPrice', { companyCode: common.getCompanyName(), CustCode: param.CustCode, ItemNum: param.ItemNum, EffectiveDate: param.EffectiveDate, ToCur: param.ToCur }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getItemPriceByExRate({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/getitempricebyexrate', { companyCode: common.getCompanyName(), CustCode: param.CustCode, ItemNum: param.ItemNum, EffectiveDate: param.EffectiveDate, ToCur: param.ToCur, ExRate: param.ExRate }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getItemPriceByExRateAndUOM({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/getitempricebyexrateanduom', { companyCode: common.getCompanyName(), CustCode: param.CustCode, ItemNum: param.ItemNum, EffectiveDate: param.EffectiveDate, ToCur: param.ToCur, ExRate: param.ExRate, toUOM: param.Alt_UOM, d_qty: (param.d_qty) ? param.d_qty : 1 }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        quotedUnitPx({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/quote/QuotedUnitPx', { companyCode: common.getCompanyName(), txNum: param.CustRef, itemNum: param.ItemNum, qty: (param.d_qty) ? param.d_qty : 1 }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        // convertUnitPxBaseToAltUnit({ commit, state }, param) {
        //     return new Promise((resolve, reject) => {
        //         HTTP.post(baseUrl + '/common/convertunitpxbasetoaltunit', { altUOM: param.Alt_UOM, altValue: param.ForeignUnitPrice, itemNum: param.ItemNum }).then(response => {
        //             resolve(response);
        //         })
        //             .catch(e => {
        //                 reject(e);
        //             });
        //     });
        // },
        buildPackingDescriptionByItemNum({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/BuildPackingDescriptionByItemNum', { s_CompanyCode: common.getCompanyName(), s_ItemNum: param.itemNum }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getUnitCostWithCur({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/getunitcostwithcur', { ItemNum: param.ItemNum, Vendor: param.Vendor, Cur: param.Cur, UOM: param.UOM }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        // getCustomerModel({ commit }, param) {
        //     return new Promise((resolve, reject) => {
        //         HTTP.post(baseUrl + '/common/getcustomermodel', { entNum: param.entityNum }).then(response => {
        //             resolve(response);
        //         }).catch(e => {
        //             reject(e);
        //         });
        //     });
        // },
        getSysParam({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/getParamValue', { paramCode: param.ParamCode }).then(response => {
                    resolve(response);
                }).catch(e => {
                    reject(e);
                });
            });
        },
        getUnitCostWithUOM({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/getunitcost', { ItemNum: param.ItemNum, Vendor: param.Vendor, UOM: param.UOM }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        // getAllSysParameter({ commit, state }, param) {
        //     return new Promise((resolve, reject) => {
        //         state.q.tableNeedQuery = "SysParameter";  
        //         HTTP.post(baseUrl + "/qgl/listvalue", state.q)
        //         .then(response => {
        //             resolve(response);
        //         })
        //         .catch(e => {
        //             reject(e);
        //         });
        //     });
        // },
    }
};
export default commonStore;